export const RIGHT_TAB_DOC_META = 'DOC_META'
export const RIGHT_TAB_FAV = 'FAV'
export const RIGHT_TAB_TAGGINGMODE = 'TAGGINGMODE'
export const RIGHT_TAB_REPORT = 'REPORT'
export const RIGHT_TAB_BOOKMARK = 'BOOKMARK'
export const RIGHT_TAB_DOCTAGTRAY = 'DOCTAGTRAY'
export const RIGHT_TAB_ALT_TEXT = 'ALT_TEXT'

export const TAGGING_MODE_SINGLE = 'TAGGING_MODE_SINGLE'
export const TAGGING_MODE_CONTINUOUS = 'TAGGING_MODE_CONTINUOUS'

export const MANUAL_ORDER_STEP_1 = 'manual order'
export const MANUAL_ORDER_STEP_2 = 'end order'
export const MANUAL_ORDER_STEP_3 = 'apply order'
